﻿import Vue from "vue";
import common = require("../../common");
import context = require("../context");
import core = require("../../core");
import EditVue = require("../vue/EditVue");
import HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction");
import utilities = require("../utilities");
import FormService = require("../../services/FormService");
import SharedEmbeddedParentForm = require("../vue/hotEditable/SharedEmbeddedParentForm");
import SearchBox = require("../../core/SearchBox");

//declare function require(name: string): any;
//var jsClasses = require("../../../js/jsClasses");

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appeler lors de la sauvegarde  */
    updateApiUrl: string;
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    searchBoxSettings: common.ISearchBoxSettings;
}

class FduGenererLiens implements common.IWebComponent {
    private _isInit = false;
    private _formService: FormService;
    private _editVue = null as EditVue;
    private _loader = null as core.Loader;
    private _previousPageUrl: string;
    private _vueElId: string;
    private _updateApiUrl: string;
    private _liveUpdateOnEditMode: boolean;
    private _useBrowserHistoryToGoBackOnCancel: boolean;
    private _isEditionAlwaysOn: boolean;
    private _confirmPopup: core.ConfirmationPopup = null;
    private _customData = null as common.IPostCustomData;
    private _searchBox: SearchBox;
    onFormActionSuccessCallback = null as (action: HotEditableFormAction, data?: common.IHotEditableFormResponseData) => void;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._updateApiUrl = s.updateApiUrl || null;
        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._isEditionAlwaysOn = true; //s.isEditionAlwaysOn === true;
        this._liveUpdateOnEditMode = false;//s.liveUpdateOnEditMode === true;//default is FALSE
        this._useBrowserHistoryToGoBackOnCancel = true; //s.useBrowserHistoryToGoBackOnCancel !== false;//default is TRUE
        this._previousPageUrl = s.previousPageUrl || null;
        this._customData = {}; //s.customData || {};
        this._searchBox = new SearchBox(s.searchBoxSettings);

        this._formService = new FormService(s.formName);
        this._loader = new core.Loader(this._vueElId);
        this._confirmPopup = new core.ConfirmationPopup("#ActionConfirmPopup.mod-popup");

        this.setupVue(s);

        //if (s.appendToContextualComponents !== false)
        context.components.add(this);

        return this;
    }

    getFromCustomData(key: string) {
        if (!key)
            throw "L'argument 'key' est obligatoire."
        return this._customData[key];
    }
    setToCustomData(key: string, value?: any) {
        if (!key)
            throw "L'argument 'key' est obligatoire."
        this._customData[key] = value;
        return this;
    }
    

    destroy() {
        this._editVue.shared.destroyComponents();
        this._editVue.$destroy();
        this._editVue = null;
    }

    setSharedEmbeddedParentForm(shared: SharedEmbeddedParentForm) {
        this._editVue.shared.setSharedEmbeddedParentForm(shared);
        return this;
    }

    /** Sera appelé par le embedded field pour y injecter le navContext */
    insertNavContextHiddenField(navContextId: string) {
        utilities.insertNavContextHiddenField(this._editVue.shared.getFormName(), navContextId);
        return this;
    }
    // /** Sera appelé par le embedded field pour y injecter le sum check */
    // insertConcurrencySumCheckHiddenField(sumCheck: string) {
    //     utilities.insertConcurrencySumCheckHiddenField(this._editVue.shared.getFormName(), sumCheck);
    //     return this;
    // }
    refreshEmbeddedComponents() {
        if (this._editVue)
            this._editVue.refreshEmbeddedComponents();
    }
    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName,
            bag: null,//s.bag || null,
            loadFormModeFromUrl: false,//s.loadFormModeFromUrl !== false,
            embeddedContentModels: null,//s.embeddedContentModels || null,
            includesConcurrencySumCheck: true,
            concurrencySumCheck: null,//s.concurrencySumCheck || null
        };

        this._editVue = new EditVue();

        // if (s.disableManageButtonsOnFormModeChange === true)
        //     this._editVue.setManageButtonsOnFormModeChange(false);

        this._editVue.shared.setActionCallback(a => {
            this.onFormAction(a);
        }).setErrorCallback((errors, config) => {
            this.onFormActionError(errors, null, config);
        });

        this._editVue.shared.setupForm(this._isEditionAlwaysOn);
    }
    private onFormAction(action: HotEditableFormAction) {
        if (this._formService.actionHasError(action))
            return;

        const isEditionFormMode = action.isEditionFormMode();
        const actionValue = action.getActionValue();
        var actionType = action.getActionType();

        if (this._liveUpdateOnEditMode && actionType === common.HotEditableActionTypes.unknown)
            actionType = common.HotEditableActionTypes.update;

        if (isEditionFormMode && actionType === common.HotEditableActionTypes.unknown)
            return;

        if (actionType === common.HotEditableActionTypes.cancel && this._useBrowserHistoryToGoBackOnCancel && this._previousPageUrl) {
            utilities.redirect(this._previousPageUrl);
            return;
        }

        const post = () => {
            this._formService.validateAndPost(
                this._updateApiUrl,
                null,
                {
                    posted_actionType: actionType,
                    posted_actionValue: actionValue,
                    posted_formName: this._editVue.shared.getFormName(),
                    posted_fieldName: action.getFieldOrButtonName(),
                    posted_currentCulture: context.culture.get(),
                    posted_currentUrl: utilities.currentUrl(),
                    posted_previousPageUrl: this._previousPageUrl,
                    posted_customData: utilities.ensureCustomDataIsValid(this._customData),
                    posted_currentEmbeddedComponentName: this._editVue.shared.getCurrentEmbeddedComponentName(),
                    posted_bag: this._editVue.getBagRaw(),
                    isControlClick: action.getButtonClickContext().isCtlClick === true
                },
                (data: common.IHotEditableFormResponseData) => {
                    this.onFormActionSuccess(action, data);
                },
                (e, config) => {
                    this.onFormActionError(e, action, config);
                });
        };

        post();

        // if (this._editVue.shared.hasEditionEmbeddedForm())
        //     this.getConfirmPopup().show("Attention", "Un autre formulaire est en cours de modification. En poursuivant cette opération, tout changements apportés précédemment seront annulés. Êtes-vous certain de vouloir continuer?", post);
        // else
        //     post();
    }

    private onFormActionSuccess(action: HotEditableFormAction, data?: common.IHotEditableFormResponseData) {
        data = data || {};

        const actionType = action.getActionType();
        const actionValue = action.getActionValue();
        const isButtonClick = action.isButtonClick();
        const isEditionFormMode = action.isEditionFormMode();
        const isUpdateAction = actionType === common.HotEditableActionTypes.update;
        const isDeleteAction = !isUpdateAction && actionType === common.HotEditableActionTypes.delete;
        const showMessages = data.disableAllMessages !== true;
        const showAutoSuccessMessages = showMessages && data.disableAutomaticMessages !== true;
        const hasCustomMessages = data.messages && data.messages.length;
        const changedFieldName = action.getFieldName();
        const buttonClickContext = action.getButtonClickContext();

        // if (data.outdatedContent) {
        //     const onApply = data.outdatedContent.refreshEntirePage
        //         ? null
        //         : () => {
        //             if (data.outdatedContent.hotEmbeddedComponentsToRefresh)
        //                 this._editVue.shared.updateHotEmbeddedComponents(data.outdatedContent.hotEmbeddedComponentsToRefresh);
        //             else
        //                 this._editVue.shared.updateCurrentHotEmbeddedComponent();
        //         };
        //     context.components.getPage().showRefreshPopup(onApply, data.outdatedContent.CustomRefreshTitleHtml, data.outdatedContent.CustomRefreshMessageHtml);
        //     return;
        // }

        this.sendNoFermesToSearchBox();

        const displayCustomMessage = (immediateDisplay: boolean, text: string, name?: string, messageType?: common.MessageTypes, autoClose?: boolean) => {
            messageType = messageType || common.MessageTypes.success//<- default is success
            if (!this._editVue.shared.displayMessage(name, text, messageType))
                this._formService.displayMessage(text, messageType, immediateDisplay, autoClose);
        }

        if (data.scrollToTopOnSuccess)
            setTimeout(() => { utilities.scrollToTop(375, '.mp-content'); }, 125);

        if (this._editVue.shared.isHotEmbeddedComponent()) {
            // Widgets
            if (data.refreshBrotherEmbeddedComponents)
                this._editVue.refreshBrotherEmbeddedComponents();
            if (data.hotEmbeddedComponentsToUpdate && data.hotEmbeddedComponentsToUpdate.length) {
                const updateCurrentEmbededForm = utilities.any(data.hotEmbeddedComponentsToUpdate, x => !x.name);
                if (showMessages)
                    if (updateCurrentEmbededForm)
                        if (hasCustomMessages)
                            for (let i = 0; i < data.messages.length; i++) {
                                const m = data.messages[i];
                                const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                                displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                            }
                        // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService.displayMessage(data.messages, customMessageType, true, true);
                        else if (showAutoSuccessMessages)
                            this._formService.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);

                if (this._editVue && this._editVue.shared.updateHotEmbeddedComponents(data.hotEmbeddedComponentsToUpdate))
                    return;
            }
        }

        if (isDeleteAction) 
            if (utilities.autoRedirect(data, this._previousPageUrl))
                return;

        this._editVue.shared.updateConcurrencySumCheck(data.updatedConcurrencySumCheck);
        this._editVue.updateBag(data.bag);

        const repost = () => this._editVue.shared.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        if (FormService.confirm(
            this._editVue.formManager.getFormName(),
            this._confirmPopup,
            data.confirmationMessages,
            () => {
                // Accepted
                repost();
            },
            returnToApiOnDenied => {
                // Denied

                if (returnToApiOnDenied) {
                    repost();
                    return;
                }
                if (this._editVue.shared.confirmationRejected())
                    this._formService.displayNotSavedErrorMessageImediately();
            }))
            return;

        if (isUpdateAction || data.redirectUrl) {
            const url = data.redirectUrl || this._previousPageUrl || null;
            if (url) {
                if (showMessages)
                    if (hasCustomMessages)
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(false, m.text, m.name, m.messageType, ac);
                        }
                    // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
                    //     this._formService.displayMessage(data.messages, customMessageType, false, true);
                    else if (showAutoSuccessMessages)
                        this._formService.displaySuccessMessageFromAction(action, false, true, this._liveUpdateOnEditMode);
                utilities.redirectWithOptions(url, data.redirectUrlOptions);
                return;
            }
        }

        if (data.fieldsToUpdate)
            for (let i = 0; i < data.fieldsToUpdate.length; i++) {
                const updatedField = data.fieldsToUpdate[i];
                if (updatedField)
                    this._editVue.shared.updateFieldFromApi(updatedField);
            }

        if (showMessages)
            if (hasCustomMessages)
                for (let i = 0; i < data.messages.length; i++) {
                    const m = data.messages[i];
                    const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                    displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                }
            // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
            //     this._formService.displayMessage(data.messages, customMessageType, true, true);
            else if (showAutoSuccessMessages)
                this._formService.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);

        if (isEditionFormMode && !this._isEditionAlwaysOn && !this._liveUpdateOnEditMode)
            this._editVue.shared.setAsHotEditableFormMode();
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {

                if(context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    this._formService.displayErrorImediately(new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code));
                }
                else
                    this._formService.displayErrorImediately(new core.Error(error.message)); 

                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue.shared.displayFieldError(this._editVue.shared.getFormName(), error, true);
            if (fieldFound) {
                this._formService.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService.displayErrorImediately(new core.Error(error.message));   
        }
    }

    private sendNoFermesToSearchBox() {

        const inputValue = this._editVue.formManager.getFieldValueByName("NumeroFermes") as string;
        const inputValues = (inputValue || '').split('\n');
        var values = '';
        for (let i = 0; i < inputValues.length; i++) {
            const x = (inputValues[i] || '').trim();
            if (x !== '') {
                if (values.length)
                    values += ',';
                values += x;
            }
        }
        this._searchBox.customData.stringValues["noFermes"] = values;
        this._searchBox.refresh(null, x => {
            this._searchBox.export();
        });
    }
}

export = FduGenererLiens;